import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Menu } from 'antd';
import { SettingOutlined, PlusOutlined } from '@ant-design/icons';
import UserActions from '@Actions/userActions';
import CustomInputsV3 from '@Components/Admin/AdminConfiguration/CustomInputsV3';
import General from './General';
import Gst from './Gst';
import ListDepartment from '../../Settings/ManageTeam/Department/ListDepartment';
import PaymentTerm from './PaymentTerm';
import ExpenseAccount from './ExpenseAccount';
import data from './Tabsdata';
import Entity from './EntityTabs';
import Currencies from './Currencies';
import PaymentMode from './PaymentMode';
import './style.scss';
import LabelGeneration from './LabelGeneration';
import CFV2Actions from '@Actions/configurations/cfV2Actions';

/**
 *
 */
class AdminConfiguration extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentTab: '/general',
      fileList: [],
      uploadButton: (
        <div>
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
          </div>
        </div>
      ),

    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      getOrg, user, location, getCFV2,
    } = this.props;
    if (user?.tenant_info?.org_id) {
      getOrg(user?.tenant_info?.org_id);
      if (new URLSearchParams(location.search).get('tab')) {
        this.setState({
          currentTab: new URLSearchParams(location.search).get('tab'),
        });
      }
    }
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */

  static getDerivedStateFromProps(props, state) {
    if (props.org?.organisation?.[0]?.org_id && !state.isUserReady) {
      const { org } = props;
      return {
        ...state,
        isUserReady: true,
        organisationName: org?.organisation?.[0]?.organisation_name,
        fileList: org?.organisation?.[0]?.logo ? [{ url: org?.organisation?.[0]?.logo }] : [],
      };
    }
    return state;
  }

  /**
   *
   * @param label
   * @param key
   * @param icon
   * @param children
   * @param type
   * @return {{children, icon, label, type, key}}
   */
  getItem(label, key, icon, children, type) {
    return {
      label,
      key,
      icon,
      children,
      type,
    };
  }

  /**
   *
   * @return
   */
  render() {
    const {
      history, user,
    } = this.props;
    const {
      currentTab,
    } = this.state;

    /**
     *
     * @type {{children, icon, label, type, key}[]}
     */
    const enableLabelGeneration = this.props?.user?.tenant_info?.global_config?.sub_modules?.label_generation?.is_active;

    const items = [
      this.getItem('General', '/general'),
      this.getItem('Taxes', '/taxes'),
      this.getItem('Currencies', '/currencies'),
      this.getItem('Payment Account', '/payment-accounts'),
      this.getItem('Departments', '/departments'),
      this.getItem('Payment Terms', '/payment-terms'),
      this.getItem('Expense Accounts', '/expense-accounts'),
      this.getItem('Custom Fields', '/custom-fields'),
      enableLabelGeneration ? this.getItem('Labels', '/labels') : '',
    ].filter((val) => !!val);

    const dataItems = data(user)?.map((item) => this?.getItem(item?.name, item?.key));

    // Concatenate both sets of items
    const concatenatedItems = items?.concat(dataItems);

    // Filter out null and undefined values
    const filteredItems = concatenatedItems?.filter((item) => item !== null && item !== undefined);

    return (
      <div className="configuration-wrapper-outer">
        <Menu
          onClick={(event) => {
            history.push(`?tab=${ event.key}`);
            this.setState({ currentTab: event.key });
          }}
          style={{
            width: 256,
          }}
          selectedKeys={[currentTab]}
          defaultSelectedKeys={['/general']}
          mode="inline"
          items={filteredItems}
        />

        <div className="configuration-menu-items">
          {
            currentTab === '/general' && <General />
          }
          {
            currentTab === '/currencies' && <Currencies />
          }
          {
            currentTab === '/taxes' && <Gst tab={currentTab} />
          }
          {
            currentTab === '/departments' && <ListDepartment />
          }
          {
            currentTab === '/payment-terms' && <PaymentTerm />
          }
          {
            currentTab === '/expense-accounts' && <ExpenseAccount />
          }
          {
            currentTab === '/payment-accounts' && <PaymentMode />
          }
          {
            currentTab === '/custom-fields' && <CustomInputsV3 />
          }
          {
            enableLabelGeneration && currentTab === '/labels' && <LabelGeneration tab={currentTab} />
          }
          {
            data(user)?.map((item) => (
              currentTab === item?.key ? <Entity tabsData={item?.tabs} key={item?.key} /> : ''
            ))
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  updateOrgLoading: UserReducers.updateOrgLoading,
  org: UserReducers.org,
});
const mapDispatchToProps = (dispatch) => ({
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
  getOrg: (orgId) => dispatch(UserActions.getOrg(orgId)),
  getCFV2: (payload, callback) => dispatch(CFV2Actions.getCFV2(payload, callback)),
});


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminConfiguration));
